(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-story"] && !window.DesignMode) return;
  try {
    

  function loadSlider(callback) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.2/min/tiny-slider.js';
      script.onload = callback;
      document.head.appendChild(script);
  }
  
  function handleTabs() {
    let tabContainers = document.querySelectorAll('#ProductStory');
    if(!tabContainers) return
    
    tabContainers.forEach(function(container){      
      let products = container.querySelectorAll('.productlist .product');
      products.forEach(function(product){
        product.addEventListener('click', function(){
          products.forEach(product => product.classList.remove('active'));
          this.classList.add('active');
          let id = '#' + this.dataset.tabid;

          let tabCon = this.closest('.storyList').querySelector('.product_story--main')
          tabCon.querySelectorAll('.story_detail-container').forEach(c => c.classList.remove('is_selected'));
          tabCon.querySelector(id).classList.add('is_selected');
        });
      });  
    }); 

    if(theme.config.bpSmall) {
      let sliders = document.querySelectorAll('.storyList .product_story--main')

      sliders.forEach(slider => {
        new Flickity(slider, {
          wrapAround: true,
          contains: true,
          pageDots: false,
          cellAlign: "left",
          draggable: false 
        });
      });
    } else {
      let arrows = '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>';
      loadSlider(function() {
        tns({
          container: '.productlist',
          items: 3,
          axis: "vertical",
          swipeAngle: true,
          speed: 400,
          mouseDrag: true,
          loop: true,
          autoplay: true,
          nav: false,
          autoplayDirection: 'forward',
          mouseDrag: true,
          arrowKeys: true,
          controlsText: [arrows,arrows]
        });
      });
    }
  }

  document.addEventListener('page:loaded', function(){
    handleTabs();
  });

  } catch(e) { console.error(e); }
})();

})();
